import React from "react";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import Creation from "./Creation";

const CreateTemplate = () => {
  const { t } = useTranslation();

  return (
    <>
      <BreadCrumbs
        noTranslate
        deviceNaming
        pageName={t({ defaultMessage: "命名规则" })}
      />
      <Creation />
    </>
  );
};

export default CreateTemplate;
